import { RequestMethodEnum } from "../../../../../common/modules/httpClient/enums/RequestMethodEnum";
import { useHttpClientDispatchableOnly } from "../../../../../common/modules/httpClient/hooks/useHttpClientDispatchableOnly";

export const useChannelListService = () =>
  useHttpClientDispatchableOnly({
    url: "/integration/slackConfig/channelList/",
    method: RequestMethodEnum.GET,
  });
